import { render, staticRenderFns } from "./DeclarationImage.vue?vue&type=template&id=4da1cdc7&scoped=true&"
import script from "./DeclarationImage.vue?vue&type=script&lang=ts&"
export * from "./DeclarationImage.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationImage.vue?vue&type=style&index=0&id=4da1cdc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1cdc7",
  null
  
)

export default component.exports